import { render, staticRenderFns } from "./addDictionary.vue?vue&type=template&id=6d2b7274&scoped=true"
import script from "./addDictionary.vue?vue&type=script&lang=js"
export * from "./addDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b7274",
  null
  
)

export default component.exports